export enum FractionTypeNames {
  PROPER = 'properFraction',
  IMPROPER = 'improperFraction',
  MIXED = 'mixedFraction',
}
